import React from "react";
import { CheckCircle2, AlertCircle, Clock3 } from "lucide-react";

/**
 * Colour-coded guest check-in status pill (admin console):
 *  green — check-in form complete (universal link, emailed link, or office)
 *  red   — the guest is on site (or due today) and the form is still missing
 *  amber — arrival is still ahead; check-in pending
 */
const CheckInStatusBadge = ({ complete, onSite, testid }) => {
  if (complete) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#3B8C4E] text-white"
        data-testid={testid}
      >
        <CheckCircle2 size={10} /> Check-in complete
      </span>
    );
  }
  if (onSite) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#B3394F] text-white"
        data-testid={testid}
      >
        <AlertCircle size={10} /> Not checked in
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#C89B5F] text-white"
      data-testid={testid}
    >
      <Clock3 size={10} /> Check-in pending
    </span>
  );
};

export default CheckInStatusBadge;
